import React from 'react';
import {
	ScrollContainer,
	Wrapper,
	Title,
	BodyText,
	MessageWrapper,
	TitleText,
} from './style';

const AccessDenied = () => {
	return (
		<ScrollContainer>
			<Wrapper>
				<Title>Sorry, It looks like you do not have access yet</Title>
				<BodyText>
					Please contact sxr-clientservice@alixpartners.com to resolve the
					issue.
				</BodyText>
				<MessageWrapper>
					<TitleText>Instructions for Environment Requester :</TitleText>
					<BodyText>
						Enivornment is in Portco Mode.If you are the Environment Requester
						,please add the current User's email in Access Control Page.
					</BodyText>
				</MessageWrapper>
			</Wrapper>
		</ScrollContainer>
	);
};

const navigateToAccessDenied = (url, name) => {
	window.history.replaceState(
		{ state: { aadName: name || '', aadUrl: url } },
		'',
		'/accessdenied'
	);
	window.location.href = '/accessdenied';
};

export { AccessDenied, navigateToAccessDenied };
